import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Profile from '@int/profile_v1/lib/containers/App'

const data = {
    firstName: 'IAN',
    lastName: 'GELLER',
    avatar: '',
    headline: 'Designer, cat lover, bookworm, Apple pie fanatic and nature enthusiast',
    professionalSummary: 'Born and bred in Italy 30 years ago. Graduated at Polytechnic University of Bari in Architecture, I’ve always been passionate about social media and technology. I started working before ending my studies for a multi-platform company, proving my skills in Marketing and Social Media, Facebook campaigns, digital pr, community management, improving new social channels, strengthening the brand awareness, monitoring and analysing insights.\n\n When I was 28 I decided to push my boundaries and move to another country to experience new thing from a work and a personal point of view. I moved to London for a good job opportunity provided by 1000heads. I spent one year and a half working for clients such as GoPro, Salomon and Baileys.\n\n Now I’m based in Amsterdam and currently working for 1000heads as remote from a WeWork office located in the centre of the city.\n\n Favorite quotes:\n\n ‘Learn everything you can, anytime you can, from anyone you can, there will always come a time when you will be grateful you did.’ - Sarah Caldwell',
    address: '489  Caldwell Road, New York',
    webLink: 'gelletronics.com',
    fb: 'gelletronics.com', 
    twitter: 'gelletronics.com', 
    linkedin: 'gelletronics.com', 
    instagram: 'gelletronics.com',
  }

class ProfilePage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id="profile"><Profile data={data} /></div>
            
        );
    }
}

const mapStateToProps = ({ app, settings, user }) => ({ app, settings, user });

const mapDispatchToProps = dispatch => bindActionCreators({ }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);



// WEBPACK FOOTER //
// ./src/containers/profile/Profile.js